import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { LoginRequestModel } from "../../_models/index";
import { BaseProvider } from "../BaseProvider";
@Injectable()
export class LoginService extends BaseProvider {
    model: any = {};
    resource = "users/login?scope=full";
    constructor(private http: Http) {
        super(http);
    }
    login(loginRequest: LoginRequestModel) {
        // login an partner employee with credentials
        return this.makePostCall(this.resource, loginRequest);
    }
    getOTP(forgotPasswordRequestModel: any) {
        return this.makePostCall(
            "users/CURRENT/resetPasswordToken",
            forgotPasswordRequestModel
        );
    }
    updatePassword(updatePasswordRequestModel: any) {
        return this.makePostCall(
            "users/CURRENT/password",
            updatePasswordRequestModel
        );
    }
    passwordValidate(requestModel) {
        var resourceUrl = "passwordPolicy/validate";
        return this.makePostCall(resourceUrl, requestModel);
    }
    resetPassword(resetPasswordRequestModel: any) {
        return this.makePatchCall(
            "users/CURRENT/password",
            resetPasswordRequestModel
        );
    }

    getPasswordResetNote(channel) {
        return this.makeGetCall("passwordPolicyNote?channel=" + channel);
    }

    preOnBoard(PartnerMobileRequest: any) {
        return this.makePostCall(
            "preOnBoard",
            PartnerMobileRequest
        );
    }

    getBranches() {
        return this.makeGetCall('wsflbranches');
    }

    verifyPartnerRegistrationOtp(partnerOtpValidateRequest: any) {
        return this.makeGetCall('verifyPartnerRegistrationOtp', partnerOtpValidateRequest);
    }

    onBoardPartner(partnerRequest: any) {
        return this.makePostCall('onBoardPartner', partnerRequest);
    }
    resendOTP(otpRequest: any) {
        return this.makePostCall('resendOtp', otpRequest);

    }
}



// WEBPACK FOOTER //
// ./src/app/_services/login/login.service.ts